const ColMap = {
   
    5: [
        ["bl", "cl", "fl"],
        ["gl", "pl", "sl"],
       
    ],
    6: [
        ["br", "fr", "pr"],
        ["gr", "cr", "dr"],
        ["tr", "wr"]
    ],
    7: [
        ["sc", "sn", "sm"],
        ["st", "sp", "sw"],
        ["sk", "str", "sc"]
    ],
    8: [
        ["ch", "sh", "wh"],
        ["tw", "th", "shr"],
        ["thr", "sch", "ph"]
    ],
     9: [
        ["w1", "w2", "w3", "w4"],
        [ "w5", "w6","w7", "w8",],
        [ "w9", "w10", "w11", "w12"],
       
    ],
    10: [
      
        ["w13", "w14", "w15", "w16"],
        ["w17", "w18","w19", "w20",],
        ["w21", "w22", "w23", "w24"],
    ],
    11: [
        ["t1", "t2", "t3", "t4"],
        [ "t5", "t6","t7", "t8",],
        [ "t9", "t10", "t11", "t12"],
        
    ],
    12: [
      
        ["t13", "t14", "t15", "t16"],
        ["t17", "t18","t19", "t20",],
        ["t21", "t22", "t23", "t24"],
    ],
    
    13: [
        ["ai", "ay", "eigh"],
        ["ey", "aw", "au"],
        ["ea", "ee", "ei"]
    ],
    14: [
        ["ew", "ue", "oo"],
        ["oi", "oy", "ie"],
        ["ow", "ou", "on"]
    ],
    15: [
        ["es", "ar", "or"],
        ["en", "in", "ur"],
        ["ir", "er", "oa"]
    ],
    16: [
        ["ail", "el", "ell"],
        ["ect", "act", "ict"],
        ["oun", "ish", "ash"]
    ],
    17: [
        ["ale", "apt", "esh"],
        ["uck", "ight", "upt"],
        ["ite", "ute", "imp"]
    ],
    18: [
        ["eel", "eal", "ook"],
        ["ept", "ion", "ush"],
        ["opt", "oft"]
    ],
}
const SeqMap = {
    9: {
        "w1": "the",
        "w2": "was",
        "w3": "they",
        "w4": "when",
        "w5": "for",
        "w6": "some",
        "w7": "could",
        "w8": "picture",
        "w9": "country",
        "w10": "don't",
        "w11": "enough",
        "w12": "sometime",
        

},
    10: {
        
        "w13": "very",
        "w14": "there",
        "w15": "do",
        "w16": "you",
        "w17": "first",
        "w18": "come",
        "w19": "our",
        "w20": "world",
        "w21": "head",
        "w22": "group",
        "w23": "movie",
        "w24": "young",

},
    11: {
        "t1": "more",
        "t2": "change",
        "t3": "high",
        "t4": "story",
        "t5": "idea",
        "t6": "above",
        "t7": "are",
        "t8": "been",
        "t9": "have",
        "t10": "to",
        "t11": "your",
        "t12": "by",
        
},
    12: {
        "t13": "people",
        "t14": "should",
        "t15": "thought",
        "t16": "something",
        "t17": "watch",
        "t18": "mountain",
        "t19": "has",
        "t20": "were",
        "t21": "who",
        "t22": "here",
        "t23": "last",
        "t24": "would",
        
},
   
    6: {

    }
}

const TableMap = {
    5: [
        // [["br", "fr", "pr"], ["cr", "gr", "tr"], ["dr", null, "wr"]],
        // [["sc", "sm", "sp", "sk"], ["sn", "st", "sw", "str"]],
        [["bl", "cl", "fl"], ["gl", "pl", "sl"]]
    ],
    6: [
        [["br", "fr", "pr"], ["cr", "gr", "tr"], ["dr", null, "wr"]],
        // [["sc", "sm", "sp", "sk"], ["sn", "st", "sw", "str"]],
        // [["bl", "cl", "fl"], ["gl", "pl", "sl"]]
    ],
    7: [
        // [["br", "fr", "pr"], ["cr", "gr", "tr"], ["dr", null, "wr"]],
        [["sc", "sm", "sp", "sk"], ["sn", "st", "sw", "str"]],
        // [["bl", "cl", "fl"], ["gl", "pl", "sl"]]
    ],
    8: [
        [["br", "fr", "pr"], ["cr", "gr", "tr"], ["dr", null, "wr"]],
        [["sc", "sm", "sp", "sk"], ["sn", "st", "sw", "str"]],
        [["bl", "cl", "fl"], ["gl", "pl", "sl"]]
    ]
}

const WordMap = {
    7:  ["tr-a-p", "fl-i-p", "sp-o-t", "pl-u-g"],
    9: ["p-ai-d", "sp-in", "sp-ou-t", "br-oi-l"],
    11: ["k-ept", "sh-ook", "sw-ell", "l-ight"],
    12: ["perform", "human", "complement"].map(dName=>`https://read21-assets.s3.amazonaws.com/assets/images/lesson/12/${dName}.png`),
    13: ["anti-", "il-", "mid-", "pre-"],
    14: ["anti-crime", "inter-lock", "semi-sweet"],
    15: ["-ing", "-ion", "-tion", "-less"],
    16: ["jump-ing", "act-ion", "bound-less"],
    17: ["busy", "four", "learn", "father"],
    18: ["k-ept", "sh-ook", "sw-ell", "l-ight"],
    20: [
        "The captain turned the ship.",
            "Of all the things in the world, she chose to be a scientist.",
            "This is really an important decision.",
            "To be successful, you must do all you can to make your talent grow.",
            "The creed of the school is written on the board."
    ],
    21: [
        "  The human body is a peculiar thing. It is made up of tiny structures called cells. Cells are the most basic structure of our bodies. All living things contain cells.\n They provide oxygen to our bodies, Vitamin D through sunlight, and nutrients from food."
    ]
}

export {
    ColMap, SeqMap, TableMap,WordMap
}